export default __webpack_public_path__ + "static/media/07.1b6801d0.png";